import {ModuleProto} from "../module-proto";
import {ModuleType} from "../types";
import {SettingsMenuTopCategory} from "../settings-module";
import {SettingsParentSection} from "../../../app/settings/const";

// const debug = "GuesstimateModule"
const debug = false

export class GuesstimateModule extends ModuleProto {

    constructor(moduleConfig: JSONObject) {
        super(ModuleType.GUESSTIMATE, moduleConfig);

        debug && console.log(debug, "constructor() moduleConfig=", moduleConfig)

        this.name                       = "Guesstimates"
        this.description                = "Guesstimates, a feature of the GoodDay Business Intelligence module, automatically tracks and analyzes all user activity to estimate the effort spent on each task. These \"estimated time spent\" values, referred to as Guesstimates in GoodDay, leverage self-learning algorithms that analyze past activities to estimate task completion times. While initial estimates may lack accuracy, over time and with longer date ranges, Guesstimates become more reliable, providing insights on effort distribution without the need for manual reporting by users."
        this.svgIcon                    = "isvg-guesstimate"
        this.settingsMenuTopCategory    = SettingsMenuTopCategory.ORGANIZATION
        this.typeLabel                  = "Time and Resources"
        this.settingsUrl                = "settings/guesstimate"

        this.parentSection              = SettingsParentSection.TIME

        this.canDisable                 = false
        this._isEnabled                 = true // because this.canDisable false


    }

    toJson() {
        debug && console.log(debug, "toJson() type=", this.type, "_isEnabled=", this._isEnabled)
        const result = super.toJson();
        debug && console.log(debug, "    newConfig=", result)

        return result
    }

}